import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getPollUserGroup = (id, time) => {
  return apiRequestType(apiTypes.GET, apiConstants.SOCIAL.POLL_USER_GROUP);
};

export default getPollUserGroup;
